module.exports = __webpack_public_path__ + "static/img/mpm_3.3423ea4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpm_3.jpg
// module id = FnS2
// module chunks = 1